(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('materialRegister', {
        templateUrl: 'views/components/views/materialRegister/materialRegister.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'materialRegisterService', 'logisticService', 'rememberService', 'layoutService', function ($stateParams, stateService, utilityService, modalService, translateService, materialRegisterService, logisticService, rememberService, layoutService) {
            
            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let custactNo = $stateParams.custact_no;
            let powTimeKeyno = $stateParams.powtime_keyno;
            let pKey = $stateParams.pkey;
            let materialType = $stateParams.materialtype;
            
            let variableNames = {
                projectprosess_keyno: ''
            };
            
            let translations = {
                error: '',
                confirmation: '',
                ok: ''
            };
            
            vm.model = {
                tabletSize: layoutService.getMediaQueries().tablet,
                productButtons: [
                    {
                        id: 'goto',
                        icon: 'fas fa-search',
                        color: 'primary',
                        type: 'primary',
                        onClick: () => stateService.go('selectproduct', {
                            webpage_name: stateService.getCurrentName(),
                            parm1: vm.model.edit.custact_no,
                            parm2: vm.model.edit.powtime_keyno
                        })
                    }
                ],
                edit: {},
                selectListProcesses: [],
                selectListDepartments: [],
                itemsListLastRegisteredMaterials: [],
                searchingBarcode: false,
                lockedSaveAndNew: false,
                lockedSave: false
            };
            
            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await materialRegisterService.getEdit({
                    custact_no: custactNo,
                    powtime_keyno: powTimeKeyno,
                    pkey: pKey,
                    materialtype: materialType
                }))[0];

                return Promise.all([
                    loadProcesses(),
                    loadDepartments(),
                    loadLastRegisteredMaterials()
                ]);

                return Promise;
            }

            async function loadProcesses() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;

                return vm.model.selectListProcesses = await materialRegisterService.listProcesses({ custact_no: vm.model.edit.custact_no });
            }
            
            async function loadDepartments() {
                if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;
                
                return vm.model.selectListDepartments = await logisticService.listDepartment({ businessco_no: vm.model.edit.businessco_no });
            }

            async function loadLastRegisteredMaterials() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;

                return vm.model.itemsListLastRegisteredMaterials = await materialRegisterService.listLastRegisteredMaterials({ custact_no: vm.model.edit.custact_no });
            }

		    // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'projectprosess_keyno':
                        if (utilityService.validateParmsValue(vm.model.edit[id]) !== true) return;

                        variableValue = vm.model.edit[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

		    // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region BUTTON SCAN PROCEDURE FUNCTION CALL

            vm.scanBarcode = function () {
                vm.model.searchingBarcode = true;

                if (utilityService.validateParmsValue(vm.model.edit.barcode) !== true) return;

                materialRegisterService.scanObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.searchingBarcode = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.searchingBarcode = false;
                        vm.model.edit.prod_id = response[0].prod_id;
                        vm.model.edit.prod_name = response[0].prod_name;
                        vm.model.edit.unit_name = response[0].unit_name;
                    }
                });
            }

		    // #endregion BUTTON SCAN PROCEDURE FUNCTION CALL

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL
            
            vm.saveAndNewChanges = function () {
                vm.model.lockedSaveAndNew = true;

                materialRegisterService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode < 0) {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSaveAndNew = false;
                                }
                            }]
                        });
                    } else if (response[0].errorcode > 0) {
                        modalService.show({
                            type: 'success',
                            title: translations.confirmation,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-success',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSaveAndNew = false;
                                    loadEdit();
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSaveAndNew = false;
                    }
                });
            }
            
            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                materialRegisterService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode < 0) {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else if (response[0].errorcode > 0) {
                        modalService.show({
                            type: 'success',
                            title: translations.confirmation,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-success',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                    stateService.back();
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSave = false;
                        stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'projectprosess_keyno':
                        if (utilityService.validateWatchValue(value, vm.model.edit.projectprosess_keyno) !== true) return;

                        vm.model.edit.projectprosess_keyno = value;

                        if (utilityService.validateParmsValue(vm.model.edit.projectprosess_keyno) !== true) return;

                        rememberFunc('projectprosess_keyno');
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadEdit();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
